import * as Yup from 'yup';

const nameValidationSchema = Yup.object({
  name: Yup.string()
    .trim()
    .max(40, 'validation.lessThan40Chars')
    .matches(/^[^',<>#]+$/, 'validation.invalidCharactersOnName')
    .matches(/^.*[^\\]$/, 'validation.notEndBackslash')
    .required('validation.fieldRequired'),
});

export default nameValidationSchema;
